// extracted by mini-css-extract-plugin
export default {"sub_box":"index_sub_box_c3NVW","sub_nav":"index_sub_nav_Ansb8 clearfix"};